export default function () {
  $(document).ready(function () {
    // Iterate through each authored-content-slider instance on the page
    $('.authored-content-slider').each(function () {
      const block = $(this);

      // Handle tab click event
      block.find('.authored-content-slider__tab').on('click', function () {
        let tab = $(this).data('tab');

        // Remove active class from all tabs and add it to the clicked one
        block
          .find('.authored-content-slider__tab')
          .removeClass('authored-content-slider__tab--active');
        $(this).addClass('authored-content-slider__tab--active');

        // Hide all tab content sections
        block
          .find('.authored-content-slider__tab-content')
          .removeClass('authored-content-slider__tab-content--active')
          .hide();

        // Find the corresponding tab content and make it active
        const $activeTabContent = block.find(
          `.authored-content-slider__tab-content[data-tab-content="${tab}"]`,
        );

        // Show the active tab content and initialize the Slick slider
        $activeTabContent
          .addClass('authored-content-slider__tab-content--active')
          .show(0, function () {
            initializeSlick($activeTabContent);
          });
      });

      // Automatically trigger the first tab for each slider
      const $firstTab = block.find('.authored-content-slider__tab').first();
      if ($firstTab.length > 0) {
        $firstTab.trigger('click');
      }
    });

    // Function to update classes for first and last visible slides
    function updateVisibleClasses($slider) {
      $slider
        .find('.slick-slide')
        .removeClass('is-first-visible is-last-visible');

      const $visibleSlides = $slider
        .find('.slick-slide:not(.slick-cloned)')
        .filter(function () {
          return (
            $(this).css('display') !== 'none' &&
            $(this).hasClass('slick-active')
          );
        });

      $visibleSlides.first().addClass('is-first-visible');
      $visibleSlides.last().addClass('is-last-visible');
    }

    // Function to initialize the Slick slider inside each tab
    function initializeSlick($tabContent) {
      const $slider = $tabContent.find('.authored-content-slider__slider');
      if ($slider.length > 0) {
        // Destroy the previous Slick instance if already initialized
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }

        // Initialize the Slick slider with custom settings
        $slider.addClass('slick');
        $slider.slick({
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
          arrows: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });

        // Update visibility classes after initialization
        updateVisibleClasses($slider);

        // Update visibility classes after slide change
        $slider.on('afterChange', function (event, slick, currentSlide) {
          updateVisibleClasses($slider);
        });

        // Update visibility classes on window resize
        $(window).on('resize', function () {
          updateVisibleClasses($slider);
        });
      }
    }
  });
}
